<template>
  <v-dialog width="735" v-model="values.showDialog" v-if="values.showDialog" scrollable>
    <v-card>
      <v-card-title primary-title style="padding:10">
        <v-icon color="teal" large>new_releases</v-icon>
        <span :class="$vuetify.breakpoint.smAndDown ? 'headline pl-2' : 'display-1 pl-2'"><strong>{{values.title}}</strong></span>
        <v-btn icon style="right: 0; position: absolute" slot="activator" fab @click="close()">
          <v-icon color="black">close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text style="padding-left:5px;padding-top:5px;padding-right:5px;padding-bottom:0px;">
        <div class="ma-1">
          <v-icon color="teal">lens</v-icon>
          <strong class="title">{{values.text}}</strong>
        </div>
        <iframe style="position: relative; height: 350px; width: 100%;" :src="`${values.link}`" allowfullscreen />
        <pre v-if="values['customText']" v-html="values['customText']"></pre>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn  round color="primary" dark @click="close()">Sair</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  
</template>

<script>
  export default {
    name: 'PDialogBeta',
    methods: {
      close () {
        this.$store.commit('dialogBeta/change_values', { showDialog: false })
      }
    },
    computed: {
      values () {
        return this.$store.getters[`dialogBeta/values`] || ''
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/shared/PDialogBeta.vue